/*! @azure/msal-react v3.0.15 2025-07-08 */
'use strict';
import * as React from 'react';
import { Logger, InteractionStatus, stubbedPublicClientApplication } from '@azure/msal-browser';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */
const defaultMsalContext = {
    instance: stubbedPublicClientApplication,
    inProgress: InteractionStatus.None,
    accounts: [],
    logger: new Logger({}),
};
const MsalContext = React.createContext(defaultMsalContext);
const MsalConsumer = MsalContext.Consumer;

export { MsalConsumer, MsalContext };
//# sourceMappingURL=MsalContext.js.map
